<div class="inputSearchDs__cont" [class.readOnly]="isReadonly" [class.disabled]="isDisabled" (click)="onClick()">
  <div
    class="inputSearchDs__fieldset inputSearchDs__fieldset--{{size}} failed-{{failedClass}}"
    [class.entered]="fieldsetIsActive"
    [class.focused]="isFocused"
    [class.highlight]="highlight"
    [class.disabled]="isDisabled">
    <div class="inputSearchDs__fieldset__input-flex-cont">
      <input #inputSearchDs
        class="inputSearchDs__fieldset__input inputSearchDs__fieldset__input--{{size}}" type="text" autocomplete="off"
        [class.entered]="hasValue"
        [class.highlight]="highlight"
        [class.disabled]="isDisabled"
        [placeholder]="placeholder ?? ''"
        [readOnly]="isReadonly"
        [(ngModel)]="value"
        [disabled]="isDisabled"
        (ngModelChange)="valueIsChanged($event)" />
      <ng-container *ngIf="quickCleanIsActivated">
        <app-ds-icon
          class="inputSearchDs__fieldset__quick-clear"
          [icon]="clearIcon"
          [size]="16"
          [color]="iconFillColor.Secondary"
          (click)="onClean($event)">
        </app-ds-icon>
      </ng-container>
      <button
        class="inputSearchDs__fieldset__icon inputSearchDs__fieldset__icon--{{action}}"
        aria-label="inputSearchDs--icon"
        [class.entered]="hasValue"
        [class.disabled]="isDisabled"
        (click)="onSearch()">
        <app-ds-icon
          [icon]="searchIcon"
          [color]="isDisabled ? iconFillColor.Disabled : iconFillColor.Secondary"
          [size]="20">
        </app-ds-icon>
      </button>
    </div>
  </div>
  <div *ngIf="failedMessageIsActivated" class="inputSearchDs__errorCont inputSearchDs__errorCont--{{failedClass}}">
    <app-ds-typography
      [color]="typographyErrorColor"
      [size]="fontSize"
      [text]="failedMessage">
    </app-ds-typography>
  </div>
</div>